import React from 'react';
import { Button, forwardRef, MenuButtonProps } from '@chakra-ui/react';

const PrimaryButton = forwardRef((props: MenuButtonProps, ref) => (
  <Button ref={ref} variant="primary" {...props} />
));

export default PrimaryButton;
